import React from "react";
import Login from "../../components/Login/Signup";

function SignUp() {
  return <Login signup />;
}

export default SignUp;
